/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetLocationGroupTreeParams,
  GetLocationsParams,
  SimpleLocation
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetLocationsUrl = (params?: GetLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids","locationTypes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Location/GetLocations?${stringifiedParams}` : `/api/Location/GetLocations`
}

export const getLocations = async (params?: GetLocationsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleLocation[]> => {

  return customInstance<SimpleLocation[]>(getGetLocationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationsQueryKey = (params?: GetLocationsParams,) => {
    return [
    `/api/Location/GetLocations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(params?: GetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({ signal }) => getLocations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocations>>>
export type GetLocationsQueryError = ErrorType<unknown>


export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocations>>,
          TError,
          Awaited<ReturnType<typeof getLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params?: GetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocations>>,
          TError,
          Awaited<ReturnType<typeof getLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params?: GetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params?: GetLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLocationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(params?: GetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({ signal }) => getLocations(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLocationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLocations>>>
export type GetLocationsSuspenseQueryError = ErrorType<unknown>


export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLocationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params?: GetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params?: GetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 params?: GetLocationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLocationGroupTreeUrl = (params?: GetLocationGroupTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Location/GetLocationGroupTree?${stringifiedParams}` : `/api/Location/GetLocationGroupTree`
}

export const getLocationGroupTree = async (params?: GetLocationGroupTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetLocationGroupTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLocationGroupTreeQueryKey = (params?: GetLocationGroupTreeParams,) => {
    return [
    `/api/Location/GetLocationGroupTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLocationGroupTreeQueryOptions = <TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationGroupTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationGroupTree>>> = ({ signal }) => getLocationGroupTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationGroupTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationGroupTree>>>
export type GetLocationGroupTreeQueryError = ErrorType<unknown>


export function useGetLocationGroupTree<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLocationGroupTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationGroupTree>>,
          TError,
          Awaited<ReturnType<typeof getLocationGroupTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationGroupTree<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationGroupTree>>,
          TError,
          Awaited<ReturnType<typeof getLocationGroupTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationGroupTree<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLocationGroupTree<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationGroupTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLocationGroupTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationGroupTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationGroupTree>>> = ({ signal }) => getLocationGroupTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLocationGroupTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationGroupTree>>>
export type GetLocationGroupTreeSuspenseQueryError = ErrorType<unknown>


export function useGetLocationGroupTreeSuspense<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLocationGroupTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationGroupTreeSuspense<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationGroupTreeSuspense<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLocationGroupTreeSuspense<TData = Awaited<ReturnType<typeof getLocationGroupTree>>, TError = ErrorType<unknown>>(
 params?: GetLocationGroupTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocationGroupTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationGroupTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






